import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';

export const TextInteractionsThirdParties = () => (
  <DynamicContent
    configPath={REMOTE_CONFIG_PATHS.PRIVACY_POLICY.INTERACTIONS_THIRD_PARTIES}
    renderAsHtml={true}
  />
);
